var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackageicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 172.191,
    viewBox: "0 0 144 172.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(-2.226 1.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528",
    transform: "translate(1.017 0.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M2673.238,198.05s-11.669,3.818-11.805,18.32,0,80.2,0,80.2-1.67,32.288,60.813,56.822c0,0,60.95-22.617,61.729-56.822v-80.2s1.357-13.681-12.213-18.32c-.408.407-41.526-12.621-41.526-12.621s-7.059-3.276-16.692,0C2713.543,186.244,2673.238,198.05,2673.238,198.05Z",
    transform: "translate(-2649.482 -183.899)",
    fill: "#46a5ca"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M59.837,167.791h0c-13.9-5.508-25.743-11.934-35.193-19.1a78.722,78.722,0,0,1-18-18.468,47.212,47.212,0,0,1-6.57-13.94,23.242,23.242,0,0,1-.909-5.513c0-.656-.136-65.806,0-80.2a21.669,21.669,0,0,1,1.9-8.981,18.259,18.259,0,0,1,4.052-5.618,17.616,17.616,0,0,1,5.851-3.722c.4-.118,40.3-11.816,40.3-12.621a26.7,26.7,0,0,1,8.608-1.456c.178,0,.36,0,.539.006V167.566c-.373.146-.578.222-.586.226h0Z",
    transform: "translate(11.89)",
    fill: "#1e8bb5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    transform: "translate(2.227 57.537)",
    fill: "#f61c41",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 54,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 143,
    height: 53,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M9.585.007H70.919v51.75H9.585c-5.293,0-9.743-2.236-9.583-9.583V9.591C0,4.3,1.919-.312,9.585.007Z",
    transform: "translate(2.228 59.78)",
    fill: "#c51a37"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageicon);
export default __webpack_public_path__ + "static/media/packageicon.34dbcede2559c0ed223d156488c5f4f6.svg";
export { ForwardRef as ReactComponent };